import { ShotChannelFeedWindow } from "./channel-feed-window";
import { ShotFigure } from "./figure";
import { calderWorkspace } from "./fixture-calder";
import { ENGINEERING_ENGINEER, ENGINEERING_FEED } from "./fixture-engineering";

const WORKSPACE = calderWorkspace({ sessionId: "ses_aged_receivables", sessionTitle: "Aged receivables by customer" });

/**
 * The frame's height: the composer, the controls and the fortnight's
 * entries, without a scroll. A frame 620px wide or more holds them all; a
 * narrower one's rows run longer, so it leaves out the oldest (the
 * fixture's `wideOnly`). A phone's run longer still: its frame is shorter
 * and the band fades its foot (shot-frame's fadeFootOnPhone).
 */
const FEED_HEIGHT_CLASS = "h-[800px] sm:h-[844px]";

/** The line under the engineering frame, and what the frame shows to assistive technology. */
export const ENGINEERING_FIGURE = {
  caption: `${ENGINEERING_ENGINEER}, a Mercury Labs engineer, working with the team in their Finance channel.`,
  summary:
    "The Finance channel's Feed in a sample workspace, over a fortnight with a Mercury Labs engineer. The engineer posts that Xero, HubSpot and Outlook are connected read-only and that nothing in those systems changes; that the Twin found three customers under two names and sent the matches to the Inbox to accept or decline; the firm's finance lead posts that overdue should start the day after the due date; and the engineer posts that aged receivables agrees with the customers checked by hand and is ready to switch on.",
};

/**
 * The sample workspace's Finance channel on its Feed tab, a fortnight into
 * working with a forward-deployed engineer. Decoration beside the words
 * that make the offer: the figure's summary carries what it shows.
 */
export function EngineeringWindow({ className }: { className?: string }) {
  return <ShotChannelFeedWindow tone="light" workspace={WORKSPACE} feed={ENGINEERING_FEED} aria-hidden="true" inert heightClass={FEED_HEIGHT_CLASS} className={className} />;
}

/** The engineering frame with its label and caption. */
export function EngineeringShot({ className }: { className?: string }) {
  return (
    <ShotFigure {...ENGINEERING_FIGURE}>
      <EngineeringWindow className={className} />
    </ShotFigure>
  );
}
